/*=========================================================================================
  File Name: moduleUserActions.js
  Description: User Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    addUser({ commit }, user) {
        return new Promise((resolve, reject) => {
            axios.post("/api/user-management/users", { user: user })
                .then((response) => {
                    if (response.data.resultCode === 303 && response.data.resultMessage === "DUPLICATE_ID") {
                        reject('DUPLICATE_USER_ID_MESSAGE')
                    } else if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    }
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    updateUser({ commit }, user) {
        return new Promise((resolve, reject) => {
            axios.put("/api/user-management/users", user)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    resetUser({ commit }, UUID) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/user-management/users/${UUID}`)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchUserStatus({ commit }) {
        return new Promise((resolve, reject) => {
            let userStatus = "USER_STATUS"
            axios.get(`/api/common-code-management/code-group/${userStatus}`)
                .then((response) => {
                    commit('SET_USER_STATUS', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchUserBlockedReason({ commit }) {
        return new Promise((resolve, reject) => {
            let userBlockedReason = "USER_BLOCKED_REASON"
            axios.get(`/api/common-code-management/code-group/${userBlockedReason}`)
                .then((response) => {
                    commit('SET_BLOCKED_REASON', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchSubscriptionYN({ commit }) {
        return new Promise((resolve, reject) => {
            let subscriptionYn = "SUBSCRIPTION_YN"
            axios.get(`/api/common-code-management/code-group/${subscriptionYn}`)
                .then((response) => {
                    commit('SET_SUBSCRIPTION_YN', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchUserlessDevice({commit}){
        return new Promise((resolve, reject) => {
            axios.get('/api/device-management/userlessDevices')
            .then((response) => {
                commit('SET_USERLESS_DEVICES', response.data)
                resolve(response)
            })
            .catch((error) => reject(error))
        })
    },
    fetchDevice({commit}, deviceUUID){
        return new Promise((resolve, reject) => {
            axios.get(`/api/device-management/device/${deviceUUID}`)
            .then((response) => {
                commit('SET_DEVICE_INFO', response.data)
                resolve(response)
            })
            .catch((error) => reject(error))
        })
    },
    replaceDevice({commit}, deviceUUID){
        return new Promise((resolve, reject) => {
            axios.put(`/api/device-management/replaceDevice`, deviceUUID)
            .then((response) =>{
                resolve(response)
            })
            .catch((error) => reject(error))
        })
    }
    
}